import { TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { MenuTriggerDirectiveModule } from '@adaptiva/core/menus';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { IconComponent } from '@adaptiva/widgets/icon';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { MenuComponentModule } from '@adaptiva/widgets/menu';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { AuthoringToolbarComponent } from './authoring-toolbar.component';
import { BlacklistPropertiesOverlayModule, CopyPropertiesOverlayModule } from './overlays';
import { CreateChildMenusPipe } from './pipes';

const WIDGETS: Type<any>[] = [
	ButtonComponentModule,
	ContainerComponentModule,
	IconComponent,
	InputComponentModule,
	MenuComponentModule,
	OverlayComponentModule,
	TextComponentModule,
];

const OVERLAYS: Type<any>[] = [
	BlacklistPropertiesOverlayModule,
	CopyPropertiesOverlayModule
];

@NgModule({
	imports: [
		CommonModule,
		CreateChildMenusPipe,
		MenuTriggerDirectiveModule,
		TemplateMarkerDirectiveModule,
		OVERLAYS,
		WIDGETS
	],
	declarations: [AuthoringToolbarComponent],
	exports: [AuthoringToolbarComponent]
})
export class AuthoringToolbarComponentModule {

}
